/**
 * Converte un array di oggetti in formato CSV
 * @param data Array di oggetti da convertire
 * @param headers Array di header personalizzati (opzionale)
 * @returns Stringa CSV
 */
export function convertToCSV(
  data: readonly any[] | any[],
  headers?: { field: string; headerName: string }[]
): string {
  if (data.length === 0) {
    return "";
  }

  // Se non ci sono header personalizzati, usa le chiavi del primo oggetto
  const keys = headers
    ? headers.map((h) => h.field)
    : Object.keys(data[0]).filter((key) => !key.startsWith("_")); // Escludi chiavi interne

  // Crea la riga degli header
  const headerNames = headers ? headers.map((h) => h.headerName) : keys;

  const csvHeaders = headerNames.map((header) => escapeCSVValue(header)).join(",");

  // Crea le righe dei dati
  const csvRows = data.map((row) => {
    return keys
      .map((key) => {
        const value = row[key];
        // Gestisci valori null/undefined
        if (value === null || value === undefined) {
          return "";
        }
        // Gestisci oggetti e array
        if (typeof value === "object") {
          return escapeCSVValue(JSON.stringify(value));
        }
        return escapeCSVValue(String(value));
      })
      .join(",");
  });

  return [csvHeaders, ...csvRows].join("\n");
}

/**
 * Escapa un valore per CSV (gestisce virgolette e virgole)
 */
function escapeCSVValue(value: string): string {
  if (value.includes(",") || value.includes('"') || value.includes("\n")) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/**
 * Scarica un file CSV
 * @param csvContent Contenuto CSV come stringa
 * @param filename Nome del file (senza estensione)
 */
export function downloadCSV(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", `${filename}.csv`);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}

